import { Button, ButtonProps } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

interface GhostButtonProps extends ButtonProps {
  outlined?: boolean;
  dark?: boolean;
}

/**
 * Standard outlined or text button to be reused across app.
 * @param {boolean | undefined} outlined Optionally show a border outline for the button the same color as the text.
 * @param {boolean | undefined} dark Optionally use the primary dark teal for the button color to be used on light backgrounds.
 * @returns {JSX.Element}
 */
const GhostButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'dark' && prop !== 'outlined'
})<GhostButtonProps>(({ theme, outlined, dark }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.teal && dark ? theme.palette.teal.dark : theme.palette.primary.contrastText,
  borderRadius: 6,
  minWidth: 100,
  fontSize: '0.9rem',
  fontWeight: theme.typography.fontWeightMedium,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  paddingRight: 12,
  textTransform: 'none',
  ...(outlined && {
    outline: `1px solid ${alpha(theme.palette.teal && dark ? theme.palette.teal.dark : theme.palette.primary.contrastText, 0.8)}`
  })
}));

export default GhostButton;
